import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { DialogService, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { LoginService } from '../login/login.service';
import { MeetingsService } from '../organizations/organizations-detail/organizations-meetings-detail/meetings.service';
import { OrganizationsMeetingsDetailComponent } from '../organizations/organizations-detail/organizations-meetings-detail/organizations-meetings-detail.component';
import { OrganizationsService } from '../organizations/organizations.service';
import { UsersService } from '../users/users.service';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import dayGridPlugin from '@fullcalendar/daygrid';
import esLocale from '@fullcalendar/core/locales/es';


@Component({
  selector: 'app-calendar-popup',
  templateUrl: './calendar-popup.component.html',
  styleUrls: ['./calendar-popup.component.scss']
})
export class CalendarPopupComponent implements OnInit {

  public selectedOrganization_id: any;
  public subject: any;
  public organizations: any[];
  public selectedUsers: any[];
  public names: any[];
  public users: any[];
  public user: any;
  public connectedUserPermission: any;

  public tooltip_info = {
    show: false,
    description: "",
    showType: "",
    date_from: "",
    responsible: "",
    organization: ""
  };
  public xPos = "0px";
  public yPos = "0px";


  public events: any[] = [];
  public options: any = {
    locale: esLocale,
    navLinks: true,
    plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
    defaultDate: this.config.data.meeting_date_from ? this.config.data.meeting_date_from : new Date(),
    header: {
      left: 'prev,next',
      center: 'title',
      right: 'dayGridMonth,timeGridWeek,timeGridDay'
    },
    eventClick: (e) => {
      //Se activa cuando haces clic en un evento.

      //Recoge valores:
      var event_id = e.event._def.extendedProps.event_id;
      var type = e.event._def.extendedProps.type;

      /*
      //Abre un popup u otro dependiendo del tipo de entidad:
      if (type == 'meeting') this.meetingService.get(event_id).subscribe(
        data => {
          var meeting;
          meeting = data;
          this.viewMeeting(meeting);
        }
      )
      */
    },
    dateClick: (e) => {
      //Se activa cuando haces clic en una fecha.
    },
    editable: false,
    eventRender: function (info) {
      //info.el.find('span.fc-title').attr('data-toggle', 'tooltip');  
      //info.el.find('span.fc-title').attr('title', info.event.extendedProps.description);   
    },
    eventMouseEnter: (e) => {
      window.addEventListener("mousemove", (e) => {
        this.xPos = (e.clientX-135)+"px";
        this.yPos = (e.clientY-5)+"px";
      });
      this.tooltip_info.description = e.event._def.title;
      this.tooltip_info.show = true;
      this.tooltip_info.showType = e.event._def.extendedProps.showType;
      this.tooltip_info.date_from = e.event._def.extendedProps.date_from;
      this.tooltip_info.responsible = e.event._def.extendedProps.responsible;
      this.tooltip_info.organization = e.event._def.extendedProps.organization;
      //this.tooltip = new Tooltip(e.el.outerHTML, new NgZone({enableLongStackTrace: true, shouldCoalesceEventChangeDetection: true}));
      //this.tooltip.create();
      //this.tooltip.text = "Hola";
      //this.tooltip.show();
      /*let tooltip = new Tooltip(e.el, {
       title: 'test',
       placement: 'top',
       trigger: 'hover',
       container: 'body'
       });*/
    },
    eventMouseLeave: (e) => {
      this.tooltip_info.show = false;
    },
    eventDidMount: function (info) {
      /*let tooltip = new Tooltip(info.el, {
        title: 'test',
        placement: 'top',
        trigger: 'hover',
        container: 'body'
        });
      tooltip.text = "Hola";
      tooltip.show();*/
    },
  };

  constructor(
    public meetingService: MeetingsService,
    public messageService: MessageService,
    public organizationService: OrganizationsService,
    public dialogService: DialogService,
    private config: DynamicDialogConfig,
    public route: ActivatedRoute,
    private usersService: UsersService,
    private loginService: LoginService,
  ) {

  }


  ngOnInit(): void {
    this.loadUser();
    this.loadOrganizations();
    //this.loadOrganization(this.route.snapshot.paramMap.get('id'));
    this.loadUsers();
    //this.connectedUserPermission = this.loginService.hasPermission("SEE_CALENDAR");
    this.selectedOrganization_id = this.config.data.organization_id;

  }

  loadUser() {
    this.usersService.get(this.loginService.get("userId")).subscribe(
      data => {
        this.user = data;
        this.selectedUsers = this.user.metadata?.calendarConfig?.selectedUsers;
        this.loadOrganization(this.route.snapshot.paramMap.get('id'));
      },
      error => this.messageService.add({ closable: false, severity: "error", detail: error.error.title })
    );
  }

  loadOrganization(id) {
    //TODO: No se visualiza la organización prefiltrada en el dropdown al abrir esta pantalla desde la caja de reuniones en organizations.
    if (id) this.selectedOrganization_id = parseInt(id);
    this.loadMeeting();
  }

  loadMeeting() {
    let parameters = {

    };
    if (this.selectedOrganization_id != null) Object.assign(parameters, { organization_id: this.selectedOrganization_id });
    if (this.selectedUsers != null && this.selectedUsers.length > 0) {
      Object.assign(parameters, { usersIds: this.selectedUsers });
    } else {
      Object.assign(parameters, { usersIds: [localStorage.getItem("userId")] });
    }

    //if (!this.loginService.hasPermission("SEE_CALENDAR")) Object.assign(parameters, { usersIds: [localStorage.getItem("userId")] });
    if (this.subject != null) Object.assign(parameters, { subject: this.subject });
    this.meetingService.all(parameters).subscribe(
      data => {
        this.events = data.rows.map(m => {
          return {
            title: m.subject,
            start: m.from,
            end: m.to,
            date_from: m.from,
            event_id: m.id,
            type: 'meeting',
            showType: "Reunión",
            responsible: m.responsible.name,
            organization: m.organization.name,
            backgroundColor: m.responsible.color ? m.responsible.color : null,
            textColor: "black"
          };
        });
      },
      error => this.messageService.add({ closable: false, severity: "error", detail: error.error.title })
    );
    //if (this.selectedUsers) this.loadNames();
  }

  saveSelectedUsers() {
    this.user.metadata["calendarConfig"] = { "selectedUsers": this.selectedUsers };
    this.usersService.save(this.user.id, this.user).subscribe(
      data => {
        this.user = data;
        this.loadMeeting();
      },
      error => this.messageService.add({ closable: false, severity: "error", detail: error.error.title })
    )
  }

  /*
  loadNames() {
    this.names = [];
    this.selectedUsers.forEach(userId => {
      this.usersService.get(userId).subscribe(
        data => {
          this.names.push(data.name);
        },
        error => {

        }
      );
    });
  }
  */

  loadOrganizations() {
    this.organizationService.all({}).subscribe(
      data => {
        this.organizations = data.rows;
        this.organizations.unshift({ name: "Todas", id: null });
      },
      error => this.messageService.add({ closable: false, severity: "error", detail: error.error.title })
    )
  }
  loadUsers() {
    this.usersService.all({ organization_id: this.selectedOrganization_id }).subscribe(
      data => {
        this.users = data.rows;
      },
      error => this.messageService.add({ closable: false, severity: "error", detail: error.error.title })
    )
  }
  viewMeeting(meeting) {
    const ref = this.dialogService.open(OrganizationsMeetingsDetailComponent, {
      data: {
        id: meeting ? meeting.organization_id : null,
        contactId: meeting ? meeting.contact_id : 0,
        meetingId: meeting ? meeting.id : 0,
        deactivated: meeting ? true : false
      },
      //header: meeting ? "Detalles de la reunión" : "Nueva reunión",
      width: '70%',
      /*baseZIndex: 999*/
    });
    ref.onClose.subscribe((data: any) => {
      this.loadMeeting();
    })
  }
}
